<template>
  <div class="v-video-controls">
    <div
      class="v-video-controls-inner"
      :style="{
        backgroundColor: themeOptions.colors.toolbar
      }"
    >
      <video-play :videoState="videoState" :themeOptions="themeOptions" />

      <v-spacer></v-spacer>

      <video-fullscreen
        :videoState="videoState"
        :themeOptions="themeOptions"
        class="ml-3"
      />
    </div>
  </div>
</template>

<script>
import VideoPlay from "./btn-play";
import VideoFullscreen from "./btn-fullscreen";

export default {
  components: {
    VideoPlay,
    VideoFullscreen
  },
  props: {
    themeOptions: {
      type: Object
    },
    videoState: {
      type: Object
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped lang="stylus">
.v-video-controls
  // background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  color: #fff;
  // padding-top: 30px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  transition: opacity .4s ease-in-out, transform .4s ease-in-out;

  .v-video-controls-inner
    padding: 5px 5px;
    align-items: center;
    display: flex;
    justify-content: flex-end;
    text-align: center;
</style>
